export default __webpack_public_path__ + "static/media/shape5.4bfee167.svg";